import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { colorBlack900, colorSecondary, fontFamilySecondary } from 'styles';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const Tab = styled(Link)`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 16px 0;
  font-family: ${fontFamilySecondary};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${({ $active }) => ($active ? colorSecondary : colorBlack900)};
  box-shadow: ${({ $active }) =>
    $active ? `inset 0 -3px 0 0 ${colorSecondary}` : 'none'};

  &:hover {
    opacity: 0.8;
  }
`;
